import { isConnectToSocketActon, isAuthorizeWithSocketAction, isDisconnectFromSocketAction, isSendToSocketAction } from './typeGuards';
import { SOCKET_OPENED, SOCKET_CLOSED, SOCKET_ERROR, SOCKET_MESSAGE } from './consts';
import { authorizeWithSocket, connectToSocket as connectToSocketCreator } from './actionCreators';
export let sockets = {};
export let messageQueue = {};
const connectToSocket = ({ url, protocols, type, access_token, user_id, dispatch, reconnectAttempt, reconnectTimeout }) => {
    const socket = new WebSocket(url, protocols);
    socket.onclose = (e) => {
        if (reconnectAttempt === undefined) {
            dispatch({
                type: `${type}/${SOCKET_CLOSED}`,
                payload: e
            });
        }
        if (!e.wasClean && window.navigator.onLine) {
            setTimeout(() => {
                dispatch(connectToSocketCreator({
                    type,
                    url,
                    protocols,
                    access_token,
                    user_id,
                    reconnectAttempt: reconnectAttempt === undefined ? 0 : reconnectAttempt + 1,
                    reconnectTimeout
                }));
            }, reconnectTimeout);
        }
    };
    socket.onopen = () => {
        dispatch(authorizeWithSocket(type));
    };
    socket.onmessage = (e) => {
        const parsedData = JSON.parse(e.data);
        const hasAuthorizedSuccessfully = parsedData.type === 'response_authorization' &&
            parsedData.payload &&
            parsedData.payload.status === 'success';
        if (hasAuthorizedSuccessfully) {
            dispatch({
                type: `${type}/${SOCKET_OPENED}`
            });
        }
        else {
            dispatch({
                type: `${type}/${SOCKET_MESSAGE}`,
                payload: parsedData
            });
        }
    };
    socket.onerror = (e) => {
        // we want to ignore errors while trying to reconnect
        if (reconnectAttempt === undefined) {
            dispatch({
                type: `${type}/${SOCKET_ERROR}`,
                payload: e
            });
        }
    };
    return socket;
};
const socketsMiddlewareConfigDefaults = {
    maxReconnectAttempts: Infinity,
    reconnectTimeout: 1000
};
// sonar thinks higher-order functions are difficult to understand
// redux thinks they're a great pattern
/* eslint-disable sonarjs/cognitive-complexity */
const socketsMiddleware = (config = socketsMiddlewareConfigDefaults) => (api) => (next) => (action) => {
    if (isConnectToSocketActon(action) &&
        (action.meta.reconnectAttempt === undefined ||
            (config.maxReconnectAttempts &&
                action.meta.reconnectAttempt < config.maxReconnectAttempts))) {
        sockets[action.meta.type] = connectToSocket({ dispatch: api.dispatch, ...action.meta });
    }
    if (isAuthorizeWithSocketAction(action)) {
        // TODO: uncouple from our state shape
        const user = api.getState().user;
        const auth = api.getState().auth;
        user.status &&
            sockets[action.meta.type].readyState === 1 &&
            sockets[action.meta.type].send(JSON.stringify({
                type: 'request_authorization',
                user_id: user.status.user_id,
                payload: {
                    authorization_token: auth.data.access_token
                }
            }));
    }
    // sends pending messages on connect
    if (action.type.includes(SOCKET_OPENED)) {
        const type = action.type.split('/')[0];
        /* istanbul ignore else */
        if (sockets[type].readyState === 1 && messageQueue[type]) {
            messageQueue[type].forEach((message) => sockets[type].send(message));
            delete messageQueue[type];
        }
    }
    if (isDisconnectFromSocketAction(action) &&
        sockets[action.meta.type] &&
        sockets[action.meta.type].readyState === 1) {
        sockets[action.meta.type].close();
        delete sockets[action.meta.type];
    }
    if (isSendToSocketAction(action)) {
        if (sockets[action.meta.type] && sockets[action.meta.type].readyState === 1) {
            sockets[action.meta.type].send(action.payload);
        }
        else {
            if (!messageQueue[action.meta.type]) {
                messageQueue[action.meta.type] = [];
            }
            messageQueue[action.meta.type].push(action.payload);
        }
    }
    next(action);
};
/* eslint-enable */
export default socketsMiddleware;
//# sourceMappingURL=index.js.map